var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExcellarge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-icons:microsoft-excel",
    opacity: 0.2,
    clipPath: "url(#clip0_1558_26580)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M212.6 128.179H174.431V109.095H212.6V128.179ZM212.6 139.084H174.431V158.169H212.6V139.084ZM212.6 49.1152H174.431V68.1994H212.6V49.1152ZM212.6 79.1048H174.431V98.1891H212.6V79.1048ZM212.6 169.074H174.431V188.159H212.6V169.073V169.074ZM238.964 206.698C237.873 212.369 231.057 212.505 226.504 212.696H141.715V237.233H124.785L0 215.422V24.6056L125.521 2.76749H141.715V24.4964H223.587C228.195 24.6872 233.266 24.36 237.273 27.1134C240.082 31.1484 239.809 36.2742 240 40.9087L239.891 182.842C239.755 190.776 240.627 198.873 238.964 206.698ZM99.9745 163.921C92.4501 148.654 84.7894 133.495 77.2917 118.228C84.7073 103.369 92.0142 88.4564 99.2934 73.5431C93.1045 73.8431 86.9156 74.2247 80.7544 74.6611C76.1465 85.8661 70.7756 96.7716 67.177 108.359C63.8236 97.4259 59.3798 86.902 55.3176 76.2422C49.3195 76.5694 43.3214 76.9237 37.3237 77.2781C43.6486 91.2375 50.3831 105.005 56.5172 119.046C49.2923 132.677 42.5311 146.5 35.5242 160.214C41.4947 160.459 47.4656 160.704 53.4361 160.786C57.6895 149.935 62.9784 139.493 66.6862 128.424C70.0125 140.311 75.6558 151.298 80.2908 162.667C86.8612 163.131 93.404 163.54 99.9745 163.921ZM226.997 37.4447H141.715V49.1152H163.526V68.1994H141.715V79.1048H163.526V98.1891H141.715V109.095H163.526V128.179H141.715V139.084H163.526V158.169H141.715V169.074H163.526V188.159H141.715V200.767H226.997V37.4447Z",
    fill: "#E2E8F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1558_26580"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 240,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcellarge);
export default __webpack_public_path__ + "static/media/excellarge.8b2ae85ab65e4caa472fdcf82f1067cd.svg";
export { ForwardRef as ReactComponent };